<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 10.75C11.0355 10.75 11.875 9.91053 11.875 8.875C11.875 7.83947 11.0355 7 10 7C8.96447 7 8.125 7.83947 8.125 8.875C8.125 9.91053 8.96447 10.75 10 10.75Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M6.54511 15.2894C6.22218 16.0523 6.92159 16.75 7.75001 16.75H12.25C13.0785 16.75 13.7778 16.0523 13.4549 15.2894C12.8854 13.9439 11.553 13 10 13C8.44708 13 7.1146 13.9439 6.54511 15.2894Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M10.0008 2.5V3.25M14.0912 4L13.6148 4.56776M16.2834 7.76726L15.5425 7.8979M15.5087 12.0552L14.8758 11.6898M5.90803 4L6.38444 4.56776M3.71582 7.76726L4.45673 7.8979M4.49056 12.0552L5.12345 11.6898"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CreativeInspirationIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
